<template>
    <div class="leakage-container">
    <div class="left">
        <Zuo/>
    </div>
    <div class="right">
        <Right/>
    </div>
    </div>
  </template>
  
  <script>
  import Zuo from './zuo.vue'
  import Right from './you.vue'
  export default {
    components: {
      Zuo,
      Right
    },
    data() {
      return {
        myChart: null,
        colorSet: {
          color: this.color
        },
        dataArr: this.value
      }
    },
  
  }
  </script>
  
  <style lang="less" scoped>
  .leakage-container{
    width: 100%;
    height: 100%;
    display: flex;
    padding: 0;
    margin: 0;
    .left{
      width: 50%;
      height: 100%;
      padding: 0;
      margin: 0;
    }
    .right{
      width: 50%;
      height: 100%;
      padding: 0;
      margin: 0;
    }
  }
  </style>